var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "filters__categories", attrs: { tabindex: "0" } },
    [
      _c(
        "h6",
        {
          attrs: {
            tabindex: "0",
            "aria-label": "Filter by" + _vm.categoryTitle,
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.categoryTitle) + ":\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filters__categories-filters-wrapper" },
        _vm._l(_vm.filters, function (filter) {
          return _c(
            "div",
            {
              key: filter.id,
              staticClass: "filters__categories-filter-wrapper",
            },
            [
              _c("FilterButton", {
                attrs: {
                  categoryTitle: _vm.categoryTitle,
                  id: filter.ID,
                  name: filter.Name,
                  removeFilterFromButton: () =>
                    _vm.removeFilterFromButton(filter),
                  selected: _vm.selectedIds(filter.ID),
                  selectedFilters: _vm.selectedFilters,
                  updateFilterFromButton: () =>
                    _vm.updateFilterFromButton(filter),
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }